<div class="modal-header">
    <h4 class="modal-title">Plantid for {{medID ? findName(medID) : 'Alle'}}</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <div class="table__viewport">
        <table class="table table-hover table-striped table-sm table-frame__body" style="table-layout: fixed;">
            <thead class="fixed-top position-fixed position-sticky">
            <tr>
                <th>Sag</th>
                <th *ngIf="!medID">Init</th>
                <th class="text-end">Timer</th>
            </tr>
            </thead>

            <tbody class="mb-2">
            <tr class="clickable" [ngClass]="{'active': timeBudget === selectedTimeBudget}" *ngFor="let timeBudget of timebudgets; let i = index" (click)="onSelectTimeBudget(timeBudget)">
                <td>{{timeBudget?.name}}</td>
                <td *ngIf="!medID">{{findInit(timeBudget?.medID)}}</td>
                <td class="text-end">{{ timeBudget?.hours | time }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onDismiss()">Luk</button>
</div>
